import { render } from "./WCLoginMenuV2.vue?vue&type=template&id=78745838&scoped=true"
import script from "./WCLoginMenuV2.vue?vue&type=script&lang=js"
export * from "./WCLoginMenuV2.vue?vue&type=script&lang=js"

import "./WCLoginMenuV2.vue?vue&type=style&index=0&id=78745838&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78745838"]])

export default __exports__